import(/* webpackMode: "eager" */ "/codegiant/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/codegiant/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/codegiant/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/codegiant/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/codegiant/components/ui/tooltip.tsx");
